/*
 * @Author: zx
 */
import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "home",
        component: Layout,
        children: [
            {
                path: "/",
                name: "首页",
                component: (resolve) => require(["../view/home.vue"], resolve),
                meta: { title: "首页", icon: "el-icon-edit" },
            },
        ],
    },
    {
        path: "/platform",
        name: "platform",
        component: Layout,
        children: [
            {
                path: "/platform",
                name: "平台入驻",
                component: (resolve) => require(["../view/platformInto.vue"], resolve),
                meta: { title: "平台入驻", icon: "el-icon-edit" },
            },
        ],
    },
    {
        path: "/dataDeclaration",
        name: "dataDeclaration",
        component: Layout,
        children: [
            {
                path: "/dataDeclaration",
                name: "数据申报",
                component: (resolve) =>
                    require(["../view/dataDeclaration.vue"], resolve),
                meta: { title: "数据申报", icon: "el-icon-edit" },
            },
        ],
    },
    {
        path: "/testArea",
        name: "testArea",
        component: Layout,
        children: [
            {
                path: "/testArea",
                name: "综试区",
                component: (resolve) => require(["../view/testArea.vue"], resolve),
                meta: { title: "综试区", icon: "el-icon-edit" },
            },
        ],
    },
    {
        path: "/navigationAffairs",
        name: "navigationAffairs",
        component: Layout,
        children: [
            {
                path: "/navigationAffairs",
                name: "政务导航",
                component: (resolve) =>
                    require(["../view/navigationAffairs.vue"], resolve),
                meta: { title: "政务导航", icon: "el-icon-edit" },
            },
        ],
    },
    {
        path: "/dataServices",
        name: "dataServices",
        component: Layout,
        children: [
            {
                path: "/dataServices",
                name: "大数据服务",
                component: (resolve) => require(["../view/dataServices.vue"], resolve),
                meta: { title: "大数据服务", icon: "el-icon-edit" },
            },
        ],
    },
    {
        path: "/documents",
        name: "documents",
        component: Layout,
        children: [
            {
                path: "/documents",
                name: "documents1",
                component: (resolve) => require(["../view/documents.vue"], resolve),
                meta: { title: "资料文档", icon: "el-icon-edit" },
            },
        ],
    },
    {
        path: "/informationList",
        name: "informationList",
        component: Layout,
        children: [
            {
                path: "/informationList",
                name: "informationList",
                component: (resolve) => require(["../view/informationList.vue"], resolve),
                meta: { title: "资讯列表", icon: "el-icon-edit" },
            },
        ],
    },
    {
        path: "/informationDtl",
        name: "informationDtl",
        component: Layout,
        children: [
            {
                path: "/informationDtl",
                name: "informationDtl",
                component: (resolve) => require(["../view/informationDtl.vue"], resolve),
                meta: { title: "资讯详情", icon: "el-icon-edit" },
            },
        ],
    },
];

const router = new VueRouter({
    routes,
});

export default router;
